import { render } from "./AnswerPageFoot.vue?vue&type=template&id=36b0eb6f&scoped=true&ts=true"
import script from "./AnswerPageFoot.vue?vue&type=script&lang=ts"
export * from "./AnswerPageFoot.vue?vue&type=script&lang=ts"

import "./AnswerPageFoot.vue?vue&type=style&index=0&id=36b0eb6f&scoped=true&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b0eb6f"]])

export default __exports__